import React, { useState } from "react";
import Typography from '@mui/material/Typography';
import ImagePassword from '../../../../assets/images/logo_seguridad.png';
import { handleCreateNewPassword } from "../../../../helpers/fetch";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const inputStyle = { //Estilo para los inputs.
    backgroundColor: "var(--bg-hover-by-mode)",
    color: "var(--bg-text-inbox-by-mode)"
}

const iconVisibilityStyle = {
    position: "relative",
    top: "6px",
    left: "250px",
    color: "var(--bg-border-by-mode)"
}

const ModalDialogContent = ({ setPasswordEditedSuccess, setOpenCreateNewPassword, messageError, setMessageError, putPasswordError, setPutPasswordError }) => {
    const [securePassword, setSecurePassword] = useState(false);
    const [visibilityModeNewPassword, setVisibilityModeNewPassword] = useState("password");
    const [visibilityModeTwo, setVisibilityModeTwo] = useState("password");
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordConfirmed, setNewPasswordConfirmed] = useState("");

    const handleChangeVisibilityMode = () => {
        if (visibilityModeNewPassword === "password") {
            setVisibilityModeNewPassword("text");
        }
        if (visibilityModeNewPassword === "text") {
            setVisibilityModeNewPassword("password");
        }
    };

    const handleChangeVisibilityModeTwo = () => {
        if (visibilityModeTwo === "password") {
            setVisibilityModeTwo("text");
        }
        if (visibilityModeTwo === "text") {
            setVisibilityModeTwo("password");
        }
    };

    const handleCurrentPassword = (e) => {
        setCurrentPassword(e.target.value);
        setPutPasswordError(false);
    };

    const handleChangeNewPassword = (e) => { // Función para comprobar que la contraseña ingresada tenga más de 8 carácteres.
        setNewPassword(e.target.value);
        setMessageError(false);
        if (e.target.value.length < 8) setSecurePassword(true);
        else setSecurePassword(false)
    };

    const handleChangeNewPasswordConfirmed = (e) => {
        setNewPasswordConfirmed(e.target.value);
        if (e.target.value !== newPassword) setMessageError(true)
        else setMessageError(false)
    };

    const handleCreatePassword = async () => {
        try {
            if (!securePassword && !messageError && (newPassword === newPasswordConfirmed)) {
                console.log("esto voy a enviar", currentPassword, newPassword)
                let newPasswordData = await handleCreateNewPassword({ password: currentPassword, newPassword: newPassword });
                if (newPasswordData.data) {
                    setOpenCreateNewPassword(false);
                    setPutPasswordError(false);
                    setPasswordEditedSuccess(true);
                }
                else {
                    setPutPasswordError(true);
                }
            }
            else if (newPassword !== newPasswordConfirmed) {
                console.log("las contraseña son distinas")
                setMessageError(true);
            }
        } catch (error) {
            console.log("error al darle enviar contraseña nueva", error);
        }
    };

    return (
        <>
            <div className="container-image">
                <img src={ImagePassword} alt="" className="content-image__change-passaword" />
            </div>
            <div>
                <div style={{ display: "flex", justifyContent: "right"}}>
                    <input placeholder="Contraseña Actual *" type='password' style={inputStyle}
                        onChange={handleCurrentPassword} />
                </div>
                {putPasswordError && <Typography id="modal-modal-description" sx={{ display: "flex", justifyContent: "center", color: "var(--red-color)" }}>
                    Contraseña Actual incorrecta *
                </Typography>}
                <Typography fontFamily="Poppins" sx={{ display: "flex", justifyContent: "center", marginBottom: "15px", marginTop: "15px", fontSize: "14px" }} >
                    Utiliza al menos 8 carácteres
                </Typography>
                <div>
                    {visibilityModeNewPassword === "password" && <VisibilityIcon onClick={handleChangeVisibilityMode} sx={iconVisibilityStyle} />}
                    {visibilityModeNewPassword === "text" && <VisibilityOffIcon onClick={handleChangeVisibilityMode} sx={iconVisibilityStyle} />}
                    <input placeholder="Contraseña Nueva *" type={visibilityModeNewPassword} style={inputStyle}
                        onChange={handleChangeNewPassword} />
                </div>
                {securePassword && <Typography fontFamily="Poppins" sx={{ display: "flex", justifyContent: "center", color: "var(--red-color)", marginBottom: "15px" }} >
                    Al menos de 8 carácteres *
                </Typography>}
                <div>
                    {visibilityModeTwo === "password" && <VisibilityIcon onClick={handleChangeVisibilityModeTwo} sx={iconVisibilityStyle} />}
                    {visibilityModeTwo === "text" && <VisibilityOffIcon onClick={handleChangeVisibilityModeTwo} sx={iconVisibilityStyle} />}
                    <input placeholder="Confirmación *" type={visibilityModeTwo} style={inputStyle}
                        onChange={handleChangeNewPasswordConfirmed} />
                </div>
                {messageError && <Typography fontFamily="Poppins" sx={{ display: "flex", justifyContent: "center", color: "var(--red-color)" }} >
                    Las contraseñas no coinciden *
                </Typography>}
                <Typography id="modal-modal-description" sx={{ mt: 2 }} fontFamily="Poppins" justifyContent="center" display="flex">
                    <button className="btn-submit-info" onClick={handleCreatePassword}>Guardar Contraseña</button>
                </Typography>
            </div>
        </>
    )
};

export default ModalDialogContent;